import { AlertAccessPopup, ContentBucketFailPopup, LocationAccessPopup } from '../../ui';

export type PopupType = 'alert_access' | 'location_access' | 'bucket_failed';

// 팝업 타입을 상수로 정의
export const POPUP_TYPES: Record<string, PopupType> = {
	ALERT_ACCESS: 'alert_access',
	LOCATION_ACCESS: 'location_access',
	BUCKET_FAILED: 'bucket_failed',
} as const;

// 팝업 타입과 컴포넌트 매핑
export const POPUP_COMPONENTS = {
	[POPUP_TYPES.ALERT_ACCESS]: AlertAccessPopup,
	[POPUP_TYPES.LOCATION_ACCESS]: LocationAccessPopup,
	[POPUP_TYPES.BUCKET_FAILED]: ContentBucketFailPopup,
};
